export default __webpack_public_path__ + "static/media/abogado.04e7fe36.png";